// extracted by mini-css-extract-plugin
module.exports = {"monetaryValue":"_dfd69e8","buttonsContainer":"_a858425","cancelIcon":"_f6191b1","disabled":"_2712722","containerError":"_3d257ff","error":"_b46fb87","errorIcon":"_8ed59a4"};